import { extend } from 'vee-validate';

import { useVueI18n } from '@/composables/useVueI18n';

import { translations as t } from './validationRules.translations';

export function useValidationRules() {
    const translator = useVueI18n();

    extend('unique_user', {
        message(field, params) {
            const matchesAssignTo = String(params._assignTo_) === String(params._value_);
            const matchesReviewer = String(params._reviewer_) === String(params._value_);

            if (matchesAssignTo && matchesReviewer) {
                return translator.t(t.uniqueUserBoth, { field, assignTo: params.assignTo, reviewer: params.reviewer });
            }

            if (matchesAssignTo) {
                return translator.t(t.uniqueUserAssignTo, { field, assignTo: params.assignTo });
            }

            if (matchesReviewer) {
                return translator.t(t.uniqueUserReviewer, { field, reviewer: params.reviewer });
            }

            return '';
        },
        params: ['assignTo', 'reviewer'],
        validate: (value, params) => {
            return Object.values(params)
                .filter((param: number) => param !== null || param !== '')
                .every((param: number) => String(param) !== String(value));
        },
    });

    extend('invalid_if_empty_target', {
        message: translator.t(t.invalidIfEmptyTarget),
        params: [{ isTarget: true, name: 'target' }],
        /* eslint-disable-next-line */
        validate(_value: string, params: Record<string, any>) {
            return params.target !== '';
        },
    });
}
